module.exports = __webpack_public_path__ + "img/logo-dark.cbbc440d.svg";